import { get, post } from '../../utils/axios'

export const listIncomeLoanHomeAPI = async (params) => {
  return await get('income/loan/home', params)
}
export const importIncomeLoanHomeAPI = async (body) => {
  return await post('income/loan/home/import', body)
}
export const delIncomeLoanHomeAPI = async (body) => {
  return await post('income/loan/home/delete', body)
}
export const detailIncomeLoanHomeAPI = async (body) => {
  return await get('income/loan/home/detail', body)
}

export const getIncomeLoanHomeAccountDetailAPI = async (params) => {
  return await get('income/loan/home/account/detail', params)
}

export const createIncomeLoanHomeAccountAPI = async (body) => {
  return await post('income/loan/home/account/create', body)
}

export const updateIncomeLoanHomeAccountAPI = async (body) => {
  return await post('income/loan/home/account/update', body)
}

export const deleteIncomeLoanHomeAccountAPI = async (body) => {
  return await post('income/loan/home/account/delete', body)
}
